import Cabecera from './cabecera.jpg'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useState, useEffect } from 'react'

export default function App() {
const back = "https://inscripcion.ar:8005/"

const formato1 = "sm:text-sm lg:text-lg py-5 flex flex-col items-start"
const formato2 = "mr-10 w-64 font-semibold"
const formato3 = "capitalize border-b-2 bg-gray-990 hover:border-red-600 focus:border-red-600 outline-0"
const formato4 = "capitalize outline-0 text-sm"
const formato_mail = "border-b-2 bg-gray-990 hover:border-red-600 focus:border-red-600 outline-0" 

const [prov, setProv] = useState(21)
const [provincia, setProvincia] = useState([])

useEffect (() => {
  function traer ()  {
    fetch(back + 'traer_provincia')
    .then (response => response.json())
    .then (json => setProvincia(json))
  }

traer()
},[])

const mostrar_provincias = provincia.map((a) => {
  return <option value={a.id} key={a.id}>{a.nombre}</option>
})


const initialValues = {
    apellido: '',
    nombre: '',
    email: '',
    telefono: '',
    documento: '',
    localidad: '',
    empresa: '',
    ocupacion: ''
  }

  const validate = ((values) => {
    const errors = {}
    if (!values.apellido) 
      errors.apellido = 'Apellido requerido'
    if (!values.nombre) 
      errors.nombre = 'Nombre requerido'
    if (!values.documento)
      errors.documento = 'Documento requerido'
    else {
      if ((values.documento).length<7) 
        errors.documento = 'Faltan dígitos'
      if ((values.documento).length>8)
        errors.documento = 'Sobran dígitos'
      if (! /^[0-9]+$/.test(values.documento))
        errors.documento = 'Solo dígitos'
    }
    if (!values.telefono)
      errors.telefono='Teléfono requerido'
    else
      if (! /^[0-9]+$/.test(values.telefono))
        errors.telefono = 'Solo dígitos'
    if (!values.email)
      errors.email = 'Correo Electrónico requerido'
    else 
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) 
      errors.email = 'Correo electrónico inválido'
    if (!values.empresa)
      errors.empresa = 'Empresa requerida'
    if (!values.ocupacion)
      errors.ocupacion = 'Ocupacióm requerida'
    if (!values.localidad)
      errors.localidad = 'Localidad requerida'
    return errors;
  })

  
  const onSubmit = ((values) => {
    setHabilitado(false)
    values = {...values, provincia : prov}
    var data = {
      body: JSON.stringify(values),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }
    fetch(back + 'inscribir',data)
    .then (response => response.json())
    .then (json => {if (json.res==='rechazar') {
        setRechazado(1)
    } 
  })
  })
    const [habilitado, setHabilitado] = useState(true)
    const [rechazado, setRechazado] = useState(0)
   
    
//    const time = setTimeout(() => {
//      setHabilitado(true)
//      return ''
//    }, 10000)

    return (
     <div className="flex flex-col items-center w-full p-2 bg-blue-200">
      <div className="flex flex-col bg-white sm:w-full md:w-3/5">
        <img src={Cabecera} alt="Imagen del evento"/>
        {habilitado ? (<>
        <div className="sm:text-lg md:text-3xl text-black font-semibold px-2 text-center mt-5 mb-2">
           <p>Formulario de Inscripción</p>
        </div>
        </>)
        : ''
        }
        {habilitado ?
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {() => (
            <Form>
              <div className="px-2">
           
              <div className={formato1}>
                <label className={formato2} htmlFor="apellido">Apellido</label>
                <Field className={formato3} type="text" name="apellido" />
                <ErrorMessage name="apellido" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="nombre">Nombre</label>
                <Field className={formato3} type="text" name="nombre" />
                <ErrorMessage name="nombre" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="documento">DNI (solo números)</label>
                <Field className={formato3} type="text" name="documento" />
                <ErrorMessage name="documento" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="empresa">Empresa</label>
                <Field className={formato3} type="text" name="empresa" />
                <ErrorMessage name="empresa" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="ocupacion">Ocupación</label>
                <Field className={formato3} type="text" name="ocupacion" />
                <ErrorMessage name="ocupacion" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}>
                <label className={formato2} htmlFor="email">Email</label>
                <Field className={formato_mail} type="email" name="email" />
                <ErrorMessage name="email" component="div" className="text-red-600"/>
              </div> 
              <div className={formato1}>
                <label className={formato2} htmlFor="telefono">Celular (característica sin 0 y sin el 15)</label>
                <Field className={formato3} type="text" name="telefono" />
                <ErrorMessage name="telefono" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}>
                <label className={formato2} htmlFor="localidad">Localidad</label>
                <Field className={formato3} type="text" name="localidad" />
                <ErrorMessage name="localidad" component="div" className="text-red-600"/>
              </div> 
              <div className={formato1}>
                <label className={formato2} htmlFor="provincia">Provincia</label>
                <Field as="select" className={formato4} name="provincia" value={prov} onChange={e => setProv(e.target.value)}>
                    {mostrar_provincias}
                </Field>
              </div>
              </div>
              <div className="flex flex-col items-center mb-5">
              
              {habilitado ? 
                <button type="submit" className="md:text-2xl mt-10 p-5 rounded-full bg-blue-200 hover:bg-blue-800 hover:text-white">
                INSCRIBIRME
                </button>
              :
                <button type="submit" className="md:text-2xl mt-10 p-5 rounded-full bg-gray-200" disabled>
                INSCRIBIRME
                </button>
                }

              </div>
            </Form>
          )}
        </Formik>
        : 
        <div className="flex flex-col mt-5 sm:text-sm sm:text-justify md:text-center md:text-lg px-2">
          {!rechazado ? (<>
              <p>Tu preinscripción al <span className="font-semibold ml-2">3er Congreso Federal Ganadero</span></p>
              <p>Nos ha llegado correctamente, recibirás por mail el código QR, para que lo presentes en el</p>
              <p>Sector de Acreditaciones el día del evento.</p>
              <br/>
              <p>En caso de no verlo en tu casilla, verificá SPAM y/o correo no deseado</p>
            </>)
          : 
          <p className="font-semibold mt-5">Este número de documento ya se encuentra registrado</p>
          }
          </div>
        }
        </div>
      </div>   
    )
  }


